import { DateTime } from "luxon";

import { LeadSource } from "../../../../models/Lead";
import { ITableQuote } from "../../../../models/Quote";
import formatDateTime from "../../../../utils/formatDateTime";
import PriceFormat from "../../../../utils/priceFormat";
import usePricingAccess from "../../../../hooks/usePricingAccess";

const parseOffer = (value?: string | null) => {
  if (!value) return null;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export default function QuoteExpandedRow({ quote }: { quote: ITableQuote }) {
  const { canViewPrices } = usePricingAccess();

  return (
    <div className="flex gap-x-8 bg-gray-50 px-6 py-3 text-xs">
      <div className="flex flex-col">
        <span className="font-bold text-gray-500">Created</span>
        <span className="text-gray-700">{formatDateTime(DateTime.fromISO(quote.created), DateTime.DATETIME_SHORT)}</span>
      </div>
      {canViewPrices && (
        <div className="flex flex-col">
          <span className="font-bold text-gray-500">Price (inc VAT)</span>
          <span className="text-gray-700">{quote.applyVAT ? PriceFormat(quote.priceWithVAT) : "N/A"}</span>
        </div>
      )}
      <div className="flex flex-col">
        <span className="font-bold text-gray-500">Source</span>
        <span className="text-gray-700">{quote.website != null ? LeadSource[quote.website] : quote.source ?? "—"}</span>
      </div>
      <div className="flex flex-col">
        <span className="font-bold text-gray-500">Exported</span>
        <span className="text-gray-700">{quote.exportedOn !== null ? "✔" : "✗"}</span>
      </div>
      <div className="flex flex-col">
        <span className="font-bold text-gray-500">EWW Engine</span>
        <span className="text-gray-700">{parseOffer(quote.vehicle?.enginesWorldwideEngineOffer) != null ? PriceFormat(parseOffer(quote.vehicle?.enginesWorldwideEngineOffer)!) : "N/A"}</span>
      </div>
      <div className="flex flex-col">
        <span className="font-bold text-gray-500">EWW VFE</span>
        <span className="text-gray-700">{parseOffer(quote.vehicle?.enginesWorldwideVfeOffer) != null ? PriceFormat(parseOffer(quote.vehicle?.enginesWorldwideVfeOffer)!) : "N/A"}</span>
      </div>
    </div>
  );
}
